import {
  type CSSVariablesResolver,
  type MantineColorsTuple,
  createTheme,
} from "@mantine/core";

// Brand colors from docs/clients/belora-mobility/belora-brand-guide.md
const LIME_GREEN = "#00d865";
const CLEAR_WHITE = "#f1f1f1";
const FOREST_GREEN = "#102223";

const lime: MantineColorsTuple = [
  "#e5fff0",
  "#b3ffd8",
  "#7affbe",
  "#3fffa3",
  "#0dff8a",
  "#00f078",
  LIME_GREEN,
  "#00b054",
  "#008540",
  "#005229",
];

export const beloraTheme = createTheme({
  primaryColor: "lime",
  primaryShade: { light: 6, dark: 7 },
  colors: { lime },
  fontFamily: "Inter, sans-serif",
  fontFamilyMonospace: "monospace",
  headings: { fontFamily: "'Clash Display', sans-serif" },
  defaultRadius: "md",
});

// Dark palette — Forest Green tint scale (Forest Green → near-white)
export const beloraCssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: {
    "--mantine-color-body": CLEAR_WHITE,
  },
  dark: {
    "--mantine-color-body": FOREST_GREEN,
    "--mantine-color-dark-9": "#0d1b1c",
    "--mantine-color-dark-8": "#0e1e1f",
    "--mantine-color-dark-7": FOREST_GREEN,
    "--mantine-color-dark-6": "#162d2e",
    "--mantine-color-dark-5": "#1e3b3c",
    "--mantine-color-dark-4": "#2a4d4e",
    "--mantine-color-dark-3": "#3d6667",
    "--mantine-color-dark-2": "#6fa0a1",
    "--mantine-color-dark-1": "#9dc4c5",
    "--mantine-color-dark-0": "#cce0e1",
  },
});
